import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import Home from './Components/Home/Home/Home';
import Contact from "./Components/Contact/Contact";
import Experience from "./Components/Experience/Experience";
import CaseStudy from "./Components/CaseStudy/CaseStudy";

function App() {


  return (
    <div className="App" id="homePage">
      <Router>
        <Switch>
          <Route exact path="/">
              <Home/>
          </Route>
          <Route path="/contact">
            <Contact/>
          </Route>
          <Route path="/experience">
            <Experience/>
          </Route>
          <Route path="/case-study">
            <CaseStudy/>
          </Route>
          <Route path="*">
            <Home/>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
